import React from 'react';
import { Link } from 'react-router-dom';
import styles from './CSS/NotFound.module.css';

const NotFound = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.errorCode}>404</h1>
      <h2 className={styles.title}>Page Not Found</h2>
      <p className={styles.description}>
        Oops! The page you're looking for seems to have gone on vacation. 
        Don't worry, these things happen to the best of us.
      </p>
      <div className={styles.illustration}>
        <svg
          width="200"
          height="200"
          viewBox="0 0 200 200"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="100" cy="100" r="90" fill="#E4E8EC" />
          <path
            d="M65 80C65 91.0457 56.0457 100 45 100C33.9543 100 25 91.0457 25 80C25 68.9543 33.9543 60 45 60C56.0457 60 65 68.9543 65 80Z"
            fill="#3498DB"
          />
          <path
            d="M175 80C175 91.0457 166.046 100 155 100C143.954 100 135 91.0457 135 80C135 68.9543 143.954 60 155 60C166.046 60 175 68.9543 175 80Z"
            fill="#3498DB"
          />
          <path
            d="M50 130C50 130 70 150 100 150C130 150 150 130 150 130"
            stroke="#2C3E50"
            strokeWidth="8"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <Link to="/" className={styles.button}>
        Return to Home
      </Link>
    </div>
  );
};

export default NotFound;